// tslint:disable-next-line:no-var-requires
const textSource: { [key: string]: [string, string] } = require("./textSource.json");

/**
 * [title, text]
 */
type FinanceKnowledgeHookResult = [string | null, string | null];

export const useFinanceKnowledge = (knowledgeKey: string): FinanceKnowledgeHookResult => {
    if (!textSource[knowledgeKey]) {
        return [null, null];
    }

    return textSource[knowledgeKey];
};
